import axios from 'axios' // 处理跨域
import util from '@/libs/utils'
import { Toast, Indicator } from 'mint-ui'
import { baseUrl, appid, amapKey } from '@/service/config'
import imgs from 'image-conversion'

// let openid = util.getCookie('OPENID')
let openid = ''
let opdata

console.log(process.env.NODE_ENV)
// request拦截器
axios.interceptors.request.use(config => {
  console.log('interceptors')
  // Do something before request is sent
  let openId = util.getStore('OPENID')
  if (openId) {
    config.headers['openId'] = openId
  }
  console.log(config.headers)
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// 同盾用款接口
const sendapi = axios.create({
  baseURL: baseUrl + '/api',
  timeout: 5000,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
})
const fetch1 = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/api' : baseUrl + '/api',
  timeout: 100000,
  headers: {'Content-Type': 'application/x-www-form-urlencoded', 'openId': util.getStore('OPENID')} //
})
// 错误拦截
fetch1.interceptors.response.use(function (response) {
  console.log('拦截1', response)
  if (response.data.status == 200 || response.data.success) {
    return response
  } else {
    // 对接了第三方进件接口，提示错误信息
    if (response.request.responseURL.indexOf('/userInfo/robOrder') > -1) {
      Toast(response.data.message)
    } else {
      // 不要提示
      if (response.data.code !== 444 && response.data.message) {
        Toast(response.data.message)
      }
    }
    return response
  }
  // 对响应数据做点什么
}, function (error) {
  // 对响应错误做点什么
  if (error.response.data.message) {
    Toast(error.response.data.message)
  } else {
    Toast(error.response.status)
  }
  return Promise.reject(error)
})
const fetch2 = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/api' : baseUrl + '/api',
  timeout: 100000,
  headers: {'Content-Type': 'application/json', 'openId': util.getStore('OPENID')}
})
// 错误拦截
fetch2.interceptors.response.use(function (response) {
  console.log('拦截2', response)
  if (response.data.success) {
    return response
  } else {
    // 不要提示
    if (response.data.code !== 444) {
      Toast(response.data.message)
    }
    return response
  }
  // 对响应数据做点什么
}, function (error) {
  // 对响应错误做点什么
  if (error.response.data.message) {
    Toast(error.response.data.message)
  } else {
    Toast(error.response.status)
  }
  return Promise.reject(error)
})
// axios.defaults.baseURL =   '/api' //: 'http://172.28.133.239:8081'
// 处理请求头部
// axios.defaults.headers['openId'] = util.getStore('OPENID')
// axios.defaults.withCredentials = true;//允许跨域

var qs = require('qs')

// -------------- 二期 2024-01 ----------------
// 获取产品列表
export const getProject = (obj, fn) => {
  var data = JSON.stringify(obj)
  fetch2.post('/project/page', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 项目分类
export const getProjectCate = (obj, fn) => {
  var data = JSON.stringify(obj)
  fetch2.post('/project/category/page', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 项目详情
export const getProjectDetail = (obj, fn) => {
  var data = JSON.stringify(obj)
  fetch2.post('/project/detail', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 我关注的项目
export const getProjectFollow = (obj, fn) => {
  setopenid()
  var data = JSON.stringify(obj)
  fetch2.post('/project/page/followed', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 获取关注状态
export const getFollowStatus = (obj, fn) => {
  fetch2.get('promoter/checkFollowStatus?projectId=' + obj.projectId).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 我团队关注的项目
export const getProjectFollowJunior = (obj, fn) => {
  var data = JSON.stringify(obj)
  fetch2.post('/project/page/followed/junior', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 项目的推广文案
export const getProjectPromote = (obj, fn) => {
  var data = JSON.stringify(obj)
  fetch2.post('/promote/copywriter/page', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 我的团队
export const getTeamInfo = (obj, fn) => {
  var data = JSON.stringify(obj)
  fetch2.post('/promoter/getTeamInfo', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 我的申请
export const geApplyList = (obj, fn) => {
  var data = JSON.stringify(obj)
  fetch2.post('/userInfo/getApplyList', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 今日邀请客户
export const getTeamInfoOfToday = (obj, fn) => {
  var data = JSON.stringify(obj)
  fetch2.post('/promoter/getTeamInfoOfToday', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 我的客户进度
export const getCustomerApplyList = (obj, fn) => {
  var data = JSON.stringify(obj)
  fetch2.post('/promoter/getCustomerApplyList', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 我团队的客户进度
export const getTeamCustomerApplyList = (obj, fn) => {
  var data = JSON.stringify(obj)
  fetch2.post('/promoter/getTeamCustomerApplyList', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 发送短信
export const getSmsCode = (obj, fn) => {
  console.log(obj)
  fetch2.post('/sms/sendCaptcha?mobile=' + obj.mobile, {}).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 关注项目
export const setProjectFollow = (obj, fn) => {
  console.log(obj)
  fetch1.post('/promoter/follow?projectId=' + obj.projectId, {}).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 取消关注
export const setProjectUnFollow = (obj, fn) => {
  console.log(obj)
  fetch1.post('/promoter/unfollow?projectId=' + obj.projectId, {}).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 推广员是否注册
export const getRegisterStatus = (obj, fn) => {
  fetch1.post('/promoter/checkRegisterStatus', {}).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}
// 推广员注册
export const registerPromoter = (obj, fn) => {
  fetch2.post('/promoter/register', obj).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

export const getLocation = (fn) => {
  fetch('https://restapi.amap.com/v3/ip?key=' + amapKey, {
    method: 'get'
  }).then(async res => {
    var data = await res.json()
    fn(data)
  })
}
// 获取第三方产品进度
export const getThirdPartyOrder = (obj, fn) => {
  console.log(obj)
  fetch1.post('/order/thirdParty/query?thirdPartyOrderId=' + obj.id, {}).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// -------------- 一期 ----------------

// 设置oppenid
export const setopenid = (id) => {
  if (id) {
    openid = id
  } else {
    openid = util.getStore('OPENID')
  }
  opdata = { openId: openid }
}

// 获取id
export const getid = (fn) => {
  fetch1.get('/index').then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 获取openid
export const getopenid = (fn) => {
  var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=" + gbk + "&response_type=code&scope=snsapi_userinfo&state="+id+"#wechat_redirect'
  fetch1.post('/index').then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 获取短信验证码
export const getCode = (phone, fn) => {
  // var data = qs.stringify({ 'phone': phone })
  var data = new FormData()
  data.append('phone', phone)
  Indicator.open({// 打开loading
    text: '提交中...',
    spinnerType: 'fading-circle'
  })
  fetch1.post('/user/getCode', data).then(function (response) {
    Indicator.close()// 关闭loading
    fn(response.data)
  }).catch(function (res) {
    Indicator.close()// 关闭loading
    console.log('获取失败')
  })
}

// 获取核心企业列表
export const selectEnterpriseList = (fn) => {
  fetch1.post('/backEnterprise/selectEnterpriseList').then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 获取账户服务列表
export const ServerList = (id, fn) => {
  var data = qs.stringify({ 'enterpriseId': id })
  fetch1.post('/server/selectServerList', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 文件上传
export const upload = (file, fn) => {
  let param = new FormData()
  let newfetch1 = fetch1
  if (!file) {
    return false
  }
  Indicator.open({// 打开loading
    text: '上传中...',
    spinnerType: 'fading-circle'
  })
  imgs.compressAccurately(file, {
    size: 200,
    type: file.type,
    width: 300,
    height: 200,
    orientation: 1,
    scale: 0.5
  }).then(res => {
    // The res in the promise is a compressed Blob type (which can be treated as a File type) file;
    let files = new window.File([res], '123456.png')
    param.append('picture', files)
    let config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    newfetch1.post('/user/upload', param, config).then(function (response) {
      Toast(response.data.message)
      response.data.data.ip = baseUrl + '/api'
      Indicator.close()// 关闭loading
      fn(response.data.data)
    }).catch(function (res) {
      Indicator.close()// 关闭loading
      console.log('获取失败')
    })
  })
}

// 提交认证
export const certification = (obj, fn) => {
  setopenid()
  var data = qs.stringify({ ...obj, ...opdata })
  Indicator.open({// 打开loading
    text: '提交中...',
    spinnerType: 'fading-circle'
  })
  fetch1.post('/userInfo/certification', data).then(function (response) {
    Indicator.close()// 关闭loading
    fn(response.data)
  }).catch(function (res) {
    Indicator.close()// 关闭loading
    console.log('获取失败')
  })
}

// 提交店审信息
export const salesmanStep = (obj, fn) => {
  setopenid()
  var data = qs.stringify({ ...obj, ...opdata })
  Indicator.open({// 打开loading
    text: '提交中...',
    spinnerType: 'fading-circle'
  })
  fetch1.post('/salesmanStep1/insertSalesmanStep', data).then(function (response) {
    Indicator.close()// 关闭loading
    fn(response.data)
  }).catch(function (res) {
    Indicator.close()// 关闭loading
    console.log('获取失败')
  })
}

// 查询店审数据
export const selectSalesmanStep = (id, fn) => {
  var data = qs.stringify({ id: id })
  fetch1.post('/salesmanStep1/selectSalesmanStep', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 查询订单列表
export const getOrderlist = (obj, fn) => {
  var data = qs.stringify(obj)
  fetch1.post('/order/selectOrder', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 查询订单详情
export const orderDetails = (obj, fn) => {
  var data = qs.stringify({ id: obj })
  fetch1.post('/order/selectOrderDetails', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 获取行业列表
export const getIndustryList = (fn) => {
  fetch1.post('/industry/selectIndustryList').then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 获取品类列表
export const getCategory = (obj, fn) => {
  var data = qs.stringify({ id: obj })
  fetch1.post('/category/selectCategoryList', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 业务员修改订单信息
export const updateorder = (obj, fn) => {
  var data = qs.stringify(obj)
  fetch1.post('/userInfo/updateEnterpriseInfo', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 业务员登录
export const clogin = (obj, fn) => {
  // var data = qs.stringify({...obj, ...opdata})
  var data = qs.stringify(obj)
  fetch1.post('/loginLog/login', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 用户注册
export const ulogin = (obj, fn) => {
  setopenid()
  var data = qs.stringify({ ...obj, ...opdata })
  fetch1.post('/user/login', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 查询是否认证
export const isCertification = (fn) => {
  setopenid()
  var data = qs.stringify(opdata)
  fetch1.post('/userInfo/isCertification', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log(res)
    console.log('获取失败')
  })
}

// 查询驳回冻结时间
export const selectOverTime = (fn) => {
  setopenid()
  var data = qs.stringify(opdata)
  fetch1.post('/userInfo/selectOverTime', data).then(function (response) {
    fn(response)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 查询个人信息/userInfo/selectUserInfo
export const getUserdata = (fn) => {
  setopenid()
  var data = qs.stringify(opdata)
  fetch1.post('/userInfo/selectUserInfo', data).then(function (response) {
    fn(response)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 修改到店时间
export const updateSubTime = (obj, fn) => {
  var data = qs.stringify(obj)
  fetch1.post('/order/updateSubTime', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 查询抢单列表
export const selectUserInfoList = (obj, fn) => {
  var data = qs.stringify(obj)
  fetch1.post('/userInfo/selectUserInfoList', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 抢单
export const robOrder = (obj, fn) => {
  var data = qs.stringify(obj)
  fetch1.post('/userInfo/robOrder', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 业务情况
export const selectByIdList = (obj, fn) => {
  let data = qs.stringify(obj)
  fetch1.post('/userInfo/selectByIdList', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 验证是否需要登录
export const isLogin = (fn) => {
  setopenid()
  var data = qs.stringify(opdata)
  fetch1.post('/user/isLogin', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 业务员驳回申请
export const rejectOrder = (id, fn) => {
  var data = qs.stringify({ id })
  fetch1.post('/salesmanStep1/rejectedSalesmanStep', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 调用第三方额度接口
export const dataSend = (obj, fn) => {
  // obj.openId = 'onPkv1KP0i_WiAvONld7PiBGflVw'
  var data = qs.stringify(obj)
  sendapi.post('/userInfo/isCertification', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

// 测试
export const test = (data, fn) => {
  fetch1.post('/contrast/attitude', JSON.parse(JSON.stringify(data))).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

export const test1 = (fn) => {
  fetch1.post('/Home/Banner/banner', JSON.parse(JSON.stringify(data))).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

export const selectList = (obj, fn) => {
  let data = qs.stringify(obj)
  fetch1.post('/document/selectList', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}

export const updateDocument = (obj, fn) => {
  let data = qs.stringify(obj)
  fetch1.post('/document/updateDocument', data).then(function (response) {
    fn(response.data)
  }).catch(function (res) {
    console.log('获取失败')
  })
}



// WEBPACK FOOTER //
// ./src/service/getdata.js